// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions } from '../duck'; 
import NewHome from '../components/NewHome';
import { push } from 'react-router-redux';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    locale: state.locale,
    localValues: state.localValues,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...actions,
    goToRedirect: (route: string) => push(route)
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(NewHome);



// WEBPACK FOOTER //
// ./src/modules/home/containers/NewHomeContainer.js